module.exports = __webpack_public_path__ + "img/mockup.b6907924.png";